import { domain } from './constants'
import { hset } from '../../modules/hash'

export function setSocketStatus(isConnected) {
  return hset(domain, 'isConnected', Boolean(isConnected))
}



// WEBPACK FOOTER //
// ./src/services/connection/actions.js